export default __webpack_public_path__ + "static/channel-8-24e6adfd07786a82b7b3adc3de75276c.jpg";